// src/components/layout/Topbar.tsx
import React from "react";
import { Icon } from "@iconify/react";
import { useLocation } from "react-router-dom";
import NotificationBell from "../NotificationBell";
import bg from "../../assets/images/sidebg.jpeg";
type Props = {
  onOpenMobile?: () => void;
  compact?: boolean;
  onToggleCompact?: () => void;
  isMobileView?: boolean;
  className?: string;
};

const Topbar: React.FC<Props> = ({
  onOpenMobile,
  compact,
  onToggleCompact,
  isMobileView,
  className = "",
}) => {
  const location = useLocation();

  // Map route paths to display names
  const routeTitleMap: Record<string, string> = {
    "/": "Dashboard",
    "/employees": "Employees",
    "/employees/details": "Employees",
    "/customers": "Customers",
    "/customers/details": "Customers",
    "/vehicles": "Vehicles",
    "/loans": "Loans",
    "/transactions": "Transaction",
    "/payments": "Payments",
    "/penalties": "Penalties",
    "/notifications": "Notifications",
    "/report": "Reports",
  };

  // Extract the path
  const currentPath = location.pathname;

  // Get title based on route, fallback if not found
  const pageTitle = routeTitleMap[currentPath] || "Welcome";
  return (
    <header
      className={`flex items-center  justify-between gap-4  shadow-md  p-2  ${className}`}
      style={{
        // background: "linear-gradient(rgb(50 21 66), rgb(48 19 65))",
        background: "#001A4A",
      }}
    >
      <div className="flex items-center gap-4">
        {/* Mobile/tablet hamburger */}
        {isMobileView && (
          <button
            onClick={onOpenMobile}
            className="p-2 rounded-md hover:bg-gray-100 text-color"
            aria-label="Open menu"
          >
            <Icon icon="mdi:menu" className="text-color" width="22" />
          </button>
        )}

        <div className="md:pl-3">
          <h2 className="text-2xl font-semibold text-color ">{pageTitle},</h2>
          <p className="text-xs text-color">
            Manage Yours Loans and Vehicle Info..!
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {/* <button className="p-2  md:mr-3 rounded-full hover:bg-blue-100 bg-blue-200 text-blue-700 cursor-pointer">
          <Icon icon="f7:bell" width="20" />
        </button> */}
        <NotificationBell />
      </div>
    </header>
  );
};

export default Topbar;
